import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-empty-message',
    standalone: true,
    imports: [],
    templateUrl: './empty-message.component.html',
    styleUrl: './empty-message.component.scss'
})
export class EmptyMessageComponent {

  @Input() description:string = "";
  @Input() icon:string = 'info';

}
